import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {CommonConstants} from "../../constants/common-constants";
import {inject, Injectable} from "@angular/core";
import {HelperService} from "../../services/helper/helper.service";
@Injectable({
    providedIn: 'root'
})

export class PermissionsService {

    constructor(private helperService: HelperService, private router :Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.helperService.checkLogin(CommonConstants.TOKEN)) {
            return true;
        } else {
            this.router.navigate(['/']);
            return false;
        }
    }
}

export const adminAuthGuardGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): any => {
    return inject(PermissionsService).canActivate(next, state);
};
